import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerreportComponent } from './customerreport.component';


const routes: Routes = [
    {
        path: '',
        component: CustomerreportComponent,
        data: {
            title: 'Customer Report'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CustomerreportRoutingModule { }
